import React from 'react';
import { IBaseElementProps } from '../BasicElement';
import { ILink } from '../Button';
export interface IVHSBreadcrumb extends IBaseElementProps {
	breadcrumbs?: ILink[];
}

const VHSBreadcrumb: React.FC<IVHSBreadcrumb> = ({
	breadcrumbs,
}) => {
	const processBreadcrumb = ( breadcrumb ) => {
		let displayLink = '';
		if (breadcrumb?.href) {
			displayLink = '<a href="' + breadcrumb.href + '">' + breadcrumb.label + '</a>';
		} else {
			// the breadcrumb is a multipart.  Split it accordingly
			if (Array.isArray(breadcrumb)) {
				breadcrumb.forEach( function( link ) {
					if ( link?.href ) {
						displayLink += '<a href="' + link.href + '">' + link.label + '</a>';
					} else {
						displayLink += '<span>' + link.label + '</span>';
					}
				});
			}
		}
		return displayLink;
	};
	return (
		<ol className="vhs-breadcrumb">
			{( breadcrumbs || []).map((breadcrumb, index) => (
				<li key={index} dangerouslySetInnerHTML={{
					__html: processBreadcrumb(breadcrumb)
				}} />
			))}
		</ol>
	);
}

export default VHSBreadcrumb;
